export enum ExpenseCategoryStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

